/**
 * Created by lu on 2017/9/12.
 */
var nb = require('../nb');
var input = require('./form/Input');
var Model = nb.define({
    parent: nb.Model,
    mapping: {
        mailInput:input
    },
    method: {
        init: function () {
            this.set('mailInput',{
                'placeholder':'电子邮件地址',
                'image':'./image/mockup/footer/arrow-right.png'
            });
        }
    }
});
module.exports = new Model();


//////////////////
// WEBPACK FOOTER
// ../src/js/model/Footer.js
// module id = 48
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32